import React, { useState } from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const UserProfileHeader = ({
  user = {
    name: 'احمد محمدی',
    plan: 'پلن طلایی',
    credits: 12,
    avatar: null,
  },
  onLogout,
  className = '',
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    setIsMenuOpen(false);
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <div className={`relative ${className}`}>
      {/* User Profile Button */}
      <Button
        variant="ghost"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="flex items-center space-x-3 space-x-reverse p-3 w-full justify-start hover:bg-muted">
        <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
          {user?.avatar ? (
            <img
              src={user?.avatar}
              alt={user?.name}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <Icon name="User" size={20} color="white" />
          )}
        </div>

        <div className="flex-1 text-right">
          <div className="font-medium text-foreground text-sm">
            {user?.name}
          </div>
          <div className="text-xs text-muted-foreground">{user?.plan}</div>
        </div>

        <Icon
          name="ChevronDown"
          size={16}
          className={`text-muted-foreground transition-transform duration-150 ${
            isMenuOpen ? 'rotate-180' : ''
          }`}
        />
      </Button>
      {/* Dropdown Menu */}
      {isMenuOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsMenuOpen(false)}
          />

          {/* Menu Content */}
          <div className="absolute top-full right-0 mt-2 w-64 bg-popover border border-border rounded-lg shadow-overlay z-50 animate-scale-in">
            <div className="p-4 border-b border-border">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                  <Icon name="User" size={24} color="white" />
                </div>
                <div>
                  <div className="font-medium text-popover-foreground">
                    {user?.name}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {user?.plan}
                  </div>
                  <div className="flex items-center mt-1">
                    <Icon
                      name="Coins"
                      size={14}
                      className="text-warning ml-1"
                    />
                    <span className="text-sm text-warning font-medium">
                      {user?.credits} اعتبار
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-2">
              <Button
                variant="ghost"
                className="w-full justify-start space-x-2 space-x-reverse text-sm"
                onClick={() => setIsMenuOpen(false)}>
                <Icon name="User" size={16} />
                <span>پروفایل کاربری</span>
              </Button>

              <Button
                variant="ghost"
                className="w-full justify-start space-x-2 space-x-reverse text-sm"
                onClick={() => setIsMenuOpen(false)}>
                <Icon name="Settings" size={16} />
                <span>تنظیمات</span>
              </Button>

              <Button
                variant="ghost"
                className="w-full justify-start space-x-2 space-x-reverse text-sm"
                onClick={() => setIsMenuOpen(false)}>
                <Icon name="CreditCard" size={16} />
                <span>خرید اعتبار</span>
              </Button>

              <div className="border-t border-border my-2" />

              <Button
                variant="ghost"
                className="w-full justify-start space-x-2 space-x-reverse text-sm text-destructive hover:text-destructive hover:bg-destructive/10"
                onClick={handleLogout}>
                <Icon name="LogOut" size={16} />
                <span>خروج از حساب</span>
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfileHeader;
